module.exports = __webpack_public_path__ + "img/branding-banner3.64528287.jpg";